import { render } from "./DeferredMessageModal.vue?vue&type=template&id=48650c2b"
import script from "./DeferredMessageModal.vue?vue&type=script&lang=js"
export * from "./DeferredMessageModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__